export const PARTNERS_HEAD_CELLS = [
  {
    id: 'position_index'
  },
  {
    id: 'id',
    label: 'ID партнёра'
  },
  {
    id: 'name',
    label: 'Наименование'
  },
  {
    id: 'bin_number',
    label: 'БИН партнёра'
  },
  {
    id: 'contact_person',
    label: 'Контактное лицо'
  },
  {
    id: 'city',
    label: 'Город',
    hideSortIcon: true
  },
  {
    id: 'status',
    label: 'Статус партнёра'
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];

export const PROMOTIONS_HEAD_CELLS = [
  {
    id: 'position_index'
  },
  {
    id: 'id',
    label: 'ID акции'
  },
  {
    id: 'cms_package_name',
    label: 'Название акции'
  },
  {
    id: 'partner_name',
    label: 'Партнёр'
  },
  {
    id: 'date_start',
    label: 'Дата начала действия'
  },
  {
    id: 'date_end',
    label: 'Дата окончания действия'
  },
  {
    id: 'status',
    label: 'Статус акции'
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];

export const ENTITY = [
  {
    value: 'all',
    label: 'Всем'
  },
  {
    value: 'files',
    label: 'По списку'
  }
];

export const PROMOCODES_GENERATOR = [
  {
    value: 'auto',
    label: 'Сформировать промокоды автоматически'
  },
  {
    value: 'files',
    label: 'Загрузить список'
  },
  {
    value: 'none',
    label: 'Не формировать промокоды'
  }
];

export const PROMOCODES_HEAD_CELLS = [
  {
    id: 'promocode_number',
    label: '№ п/п'
  },
  {
    id: 'date_of_use',
    label: 'Дата использования Промокода'
  },
  {
    id: 'date_booking',
    label: 'Дата бронирования Промокода'
  },
  {
    id: 'id',
    label: 'Номер промокода'
  },
  {
    id: 'customer_name',
    label: 'ФИО абонента'
  },
  {
    id: 'customer_iin',
    label: 'ИИН абонента'
  },
  {
    id: 'customer_id',
    label: 'ID абонента'
  },
  {
    id: 'status',
    label: 'Статус'
  }
];

export const PARTNERS_STATUSES = [
  {
    value: 'all',
    label: 'Все'
  },
  {
    value: 'Действующий',
    label: 'Действующий'
  },
  {
    value: 'Архив',
    label: 'Архив'
  }
];

export const PROMO_CODES_STATUSES = [
  {
    value: 'all',
    label: 'Все'
  },
  {
    value: 'Действующий',
    label: 'Действующий'
  },
  {
    value: 'Архивный',
    label: 'Архивный'
  },
  {
    value: 'Использован',
    label: 'Использован'
  },
  {
    value: 'Забронирован',
    label: 'Забронирован'
  }
];

export const PACKAGES_HEAD_CELLS = [
  {
    id: 'id',
    label: 'ID'
  },
  {
    id: 'name',
    label: 'Наименование пакета'
  },
  {
    id: 'code',
    label: 'код',
    hideSortIcon: true
  },
  {
    id: 'image',
    label: 'Превью',
    hideSortIcon: true
  },
  {
    id: 'status',
    label: 'Статус',
    hideSortIcon: true
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];

export const PACKAGE_NAME_MAX_LENGTH = 100;
